module.exports = __webpack_public_path__ + "img/kele.87c5c0ef.jpg";